import { AuthService } from "api/services/auth.service";
import { TokenManager } from "api/utils/tokenManager";
import React, { ReactNode } from "react";
import { Navigate } from "react-router-dom";

const isTokenExpired = (): boolean => {
  const token = TokenManager.getCleanToken();
  if (!token) return true;

  try {
    const payload = JSON.parse(atob(token.split(".")[1]));
    if (!payload.exp) return false;
    return payload.exp * 1000 < Date.now();
  } catch {
    return true;
  }
};

interface AuthProtectedProps {
  children: ReactNode;
}

const AuthProtected: React.FC<AuthProtectedProps> = ({ children }) => {
  if (!AuthService.isAuthenticated() || isTokenExpired()) {
    AuthService.logout();
    return <Navigate to={{ pathname: "/login" }} />;
  }

  return <React.Fragment>{children}</React.Fragment>;
};

export default AuthProtected;
